export default __webpack_public_path__ + "static/media/element_spec_64.81da51fa.webp";